import { useState, useEffect } from 'react';
import api from '../api';
import { useAuthStore } from '../store';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Bell, X, Megaphone } from 'lucide-react';

export default function PopupNotifications() {
  const { isAuthenticated } = useAuthStore();
  const [notifications, setNotifications] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      fetchPopupNotifications();
      // Check for new popups every 30 seconds
      const interval = setInterval(fetchPopupNotifications, 30000);
      return () => clearInterval(interval);
    }
  }, [isAuthenticated]);

  const fetchPopupNotifications = async () => {
    try {
      const response = await api.get('/notifications/popup');
      if (response.data.length > 0) {
        setNotifications(response.data);
        setCurrentIndex(0);
        setShowPopup(true);
      }
    } catch (error) {
      console.error('Failed to fetch popup notifications:', error);
    }
  };

  const handleClose = () => {
    if (currentIndex < notifications.length - 1) {
      setCurrentIndex(prev => prev + 1);
    } else {
      setShowPopup(false);
      setNotifications([]);
    }
  };

  const currentNotification = notifications[currentIndex];

  if (!showPopup || !currentNotification) return null;

  return (
    <Dialog open={showPopup} onOpenChange={setShowPopup}>
      <DialogContent className="bg-gradient-to-br from-[#0A0A0A] to-[#121212] border-2 border-[#FFD700]/50 max-w-md shadow-[0_0_50px_rgba(255,215,0,0.2)]">
        <DialogHeader>
          <div className="flex items-center justify-between">
            <DialogTitle className="text-white font-bold text-xl flex items-center gap-3">
              <div className="w-10 h-10 bg-[#FFD700]/20 rounded-full flex items-center justify-center animate-pulse">
                <Megaphone className="w-5 h-5 text-[#FFD700]" />
              </div>
              {currentNotification.title}
            </DialogTitle>
            {notifications.length > 1 && (
              <span className="text-xs text-zinc-500 bg-zinc-800 px-2 py-1 rounded">
                {currentIndex + 1} / {notifications.length}
              </span>
            )}
          </div>
        </DialogHeader>
        
        <div className="py-4">
          <p className="text-zinc-300 leading-relaxed whitespace-pre-wrap">
            {currentNotification.message}
          </p>
        </div>

        <div className="flex justify-end gap-2 pt-2">
          <Button
            onClick={handleClose}
            className="bg-[#FFD700] text-black hover:bg-[#E5C100] font-bold px-6"
            data-testid="popup-notification-close-btn"
          >
            {currentIndex < notifications.length - 1 ? 'Next' : 'Got it'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
